export default __webpack_public_path__ + "static/media/36I-120870_-44005_0.79fd7a9e.jpg";